import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';
import autobind from 'class-autobind';

import map from 'lodash/map';

import {
  setTextLinksToDisplayExternalOpenMsg
} from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

import VideoPlaylistPlayer from './video_playlist_player.jsx';

import {
  ConditionalSkipLinkForElement
} from 'zoomforth_codesbane_viewer/component_lib/skip_link_for_element.jsx';

import {
  VisuallyHiddenH3,
} from 'zoomforth_codesbane_viewer/component_lib/visually_hidden.jsx';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const VideoPlaylistInner_ViewerVersion1 = ({
  height, 
  backgroundStyle, 
  selectedContentItem, 
  getAsset,
  children, 
  ...props
})=> (
  <div className="playlist-wrapper" style={{height}}>
    <div className="playlist-wrapper-inner">
      <div className="video-player-wrapper" style={backgroundStyle}>
        {
          selectedContentItem &&
            <VideoPlaylistPlayer
              key={selectedContentItem.eid || selectedContentItem.uuid}
              contentItem={selectedContentItem}
              asset={getAsset(selectedContentItem)}
              {...props}
            />
        }
      </div>

      <div className="playlist-info-wrapper">
        { children }
      </div>
    </div>
  </div>
);

class VideoPlaylistInner_ViewerVersion2 extends Component {

  constructor() {
    super();

    this.wrapperNodeRef = null;

    autobind(this);
  }

  handleKeyDown(event) {
    const target = event.target;
    const key = event.which.toString();

    const playlist = findDOMNode(this.wrapperNodeRef);

    const triggers = Array.prototype.slice.call(playlist.querySelectorAll('.video-playlist__nav-item'));

    // 33 = Page Up, 34 = Page Down
    const ctrlModifier = (event.ctrlKey && key.match(/33|34/));

    // Is this coming from an playlist item link?
    if (target.classList.contains('video-playlist__nav-item')) {
      // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
      // 38 = Up, 40 = Down
      if (key.match(/38|40/) || ctrlModifier) {
        var index = triggers.indexOf(target);
        var direction = (key.match(/34|40/)) ? 1 : -1;
        var length = triggers.length;
        var newIndex = (index + length + direction) % length;

        triggers[newIndex].focus();

        event.preventDefault();
      } else if (key.match(/35|36/)) {
        // 35 = End, 36 = Home keyboard operations
        switch (key) {
          // Go to first playlist item
        case '36':
          triggers[0].focus();
          break;
          // Go to last playlist item
        case '35':
          triggers[triggers.length - 1].focus();
          break;
        }

        event.preventDefault();

      }

    }
  }

  handleWrapperNodeRefReceived(ref) {
    this.wrapperNodeRef = ref;

    setTextLinksToDisplayExternalOpenMsg(this.wrapperNodeRef, '.video-playlist__items a');
  }

  render() {
    const {
      height, 
      contentItems,
      backgroundStyle, 
      selectedContentItem, 
      getAsset,
      children, 
      ...props
    } = this.props;

    return (
      <ConditionalSkipLinkForElement shouldShowSkipLink={true} skipLinkText="Skip video playlist">
        <div
          style={{ height }}
          className="video-playlist-wrapper"
          ref={this.handleWrapperNodeRefReceived}
          onKeyDown={this.handleKeyDown}
        >
          <div className="video-playlist__nav" role="tablist">
            { children }
          </div>

          <div className="video-playlist__content" style={backgroundStyle}>
            <div
              className="video-playlist__pane"
              aria-label="A playlist of videos"
            >
              <div className="video-playlist__items">
                {
                  map(contentItems, (contentItem, idx)=> (
                    <div
                      key={contentItem.uuid}
                      className={classNames('video-playlist__item', {
                        'video-playlist__item--active': selectedContentItem.uuid === contentItem.uuid,
                        'visually-hidden': selectedContentItem.uuid !== contentItem.uuid,
                        'has-caption': !!contentItem.renderedCaption
                      })}
                      id={`video-${contentItem.uuid}`}
                      role="tabpanel"
                      tabIndex={selectedContentItem.uuid === contentItem.uuid ? '0' : null}
                      hidden={selectedContentItem.uuid !== contentItem.uuid ? 'hidden' : null}
                      aria-hidden={selectedContentItem.uuid !== contentItem.uuid ? 'true' : null}
                      aria-labelledby={`video-${contentItem.uuid}-tab`}
                    >
                      <VisuallyHiddenH3>
                        { contentItem.title || `Video ${idx + 1}` }
                      </VisuallyHiddenH3>

                      <VideoPlaylistPlayer
                        contentItem={contentItem}
                        selectedContentItem={selectedContentItem}
                        asset={getAsset(contentItem)}
                        {...props}
                      />

                      {
                        contentItem.renderedCaption &&
                          <div
                            className="video-playlist__item-description"
                            dangerouslySetInnerHTML={{ __html: contentItem.renderedCaption }}
                          />
                      }
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
      </ConditionalSkipLinkForElement>
    );
  }

}

const VideoPlaylistInner = (props)=> (
  <SiteViewerVersionComponentSelector>
    <VideoPlaylistInner_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <VideoPlaylistInner_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default VideoPlaylistInner;
